import { render } from "./SendIcon.vue?vue&type=template&id=588ae7dd"
import script from "./SendIcon.vue?vue&type=script&lang=js"
export * from "./SendIcon.vue?vue&type=script&lang=js"
script.render = render

export default script